/**
 * 判空 Object Array String
 */
export function isEmpty(value) {
    if (value instanceof Object) {
        return Object.keys(value).length === 0;
    }
    if (value instanceof Array) {
        return value.length === 0;
    }
    return value === '' || value === null || value === undefined;
}

/**
 * 是否字符串
 */
export function isString(str) {
    if (typeof str === 'string' || str instanceof String) {
        return true;
    }
    return false;
}

/**
 * 是否数组
 */
export function isArray(arg) {
    if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]';
    }
    return Array.isArray(arg);
}

/**
 * 获取随机整数
 */
export function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * 打乱数组元素顺序
 */
export function shuffle(arr) {
    const _arr = arr.slice();
    for (let i = 0; i < _arr.length; i++) {
        const j = randomInt(0, i);
        const t = _arr[i];
        _arr[i] = _arr[j];
        _arr[j] = t;
    }
    return _arr;
}

/**
 * 防抖函数
 */
export function debounce(func, delay = 200) {
    let timer;

    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

/**
 * 给元素增加class
 */
export function addClass(el, className) {
    if (hasClass(el, className)) {
        return;
    }
    el.className += ' ' + className;
}

/**
 * 判断是否还有class
 */
export function hasClass(el, className) {
    const reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
    return reg.test(el.className);
}

/**
 * get或者set元素的data-属性值
 */
export function getData(el, name, value) {
    const prefix = 'data-';
    name = prefix + name;
    if (value) {
        return el.setAttribute(name, value);
    } else {
        return el.getAttribute(name);
    }
}

/**
 * dom对象是否在视口内
 */
export function isVisible(el) {
    return (el.offsetWidth + el.offsetHeight) > 0;
}

export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ['Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod'
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

export function Arabia_To_SimplifiedChinese(Num) {
  for (let i = Num.length - 1; i >= 0; i--) {
      Num = Num.replace(',', '');// 替换Num中的“,”
      Num = Num.replace(' ', '');// 替换Num中的空格
  }

  // 验证输入的字符是否为数字
  if (isNaN(Num)) {
      alert('请检查小写金额是否正确');
      return;
  }

  // 字符处理完毕后开始转换，采用前后两部分分别转换(小数点为界限)
 var part = String(Num).split('.');

  // 初始化一个字符串
  var newchar = '';

  // 小数点前进行转化
  for (let i = part[0].length - 1; i >= 0; i--) {
      // 若数量超过拾亿单位，提示
      if (part[0].length > 10) {
          // alert("位数过大，无法计算");
          return '';
      }

     var tmpnewchar = '';
     var perchar = part[0].charAt(i);

      switch (perchar) {
          case '0': tmpnewchar = '零' + tmpnewchar; break;
          case '1': tmpnewchar = '一' + tmpnewchar; break;
          case '2': tmpnewchar = '二' + tmpnewchar; break;
          case '3': tmpnewchar = '三' + tmpnewchar; break;
          case '4': tmpnewchar = '四' + tmpnewchar; break;
          case '5': tmpnewchar = '五' + tmpnewchar; break;
          case '6': tmpnewchar = '六' + tmpnewchar; break;
          case '7': tmpnewchar = '七' + tmpnewchar; break;
          case '8': tmpnewchar = '八' + tmpnewchar; break;
          case '9': tmpnewchar = '九' + tmpnewchar; break;
      }
      switch (part[0].length - i - 1) {
          case 0: tmpnewchar = tmpnewchar; break;
          case 1: if (perchar != 0) tmpnewchar = tmpnewchar + '十'; break;
          case 2: if (perchar != 0) tmpnewchar = tmpnewchar + '百'; break;
          case 3: if (perchar != 0) tmpnewchar = tmpnewchar + '千'; break;
          case 4: tmpnewchar = tmpnewchar + '万'; break;
          case 5: if (perchar != 0) tmpnewchar = tmpnewchar + '十'; break;
          case 6: if (perchar != 0) tmpnewchar = tmpnewchar + '百'; break;
          case 7: if (perchar != 0) tmpnewchar = tmpnewchar + '千'; break;
          case 8: tmpnewchar = tmpnewchar + '亿'; break;
          case 9: tmpnewchar = tmpnewchar + '十'; break;
      }
      newchar = tmpnewchar + newchar;
  }
  // 替换所有无用汉字，直到没有此类无用的数字为止
  while (newchar.search('零零') != -1 || newchar.search('零亿') != -1 || newchar.search('亿万') != -1 || newchar.search('零万') != -1) {
      newchar = newchar.replace('零亿', '亿');
      newchar = newchar.replace('亿万', '亿');
      newchar = newchar.replace('零万', '万');
      newchar = newchar.replace('零零', '零');
  }
  // 替换以“一十”开头的，为“十”
  if (newchar.indexOf('一十') == 0) {
      newchar = newchar.substr(1);
  }
  // 替换以“零”结尾的，为“”
  if (newchar.lastIndexOf('零') == newchar.length - 1) {
      newchar = newchar.substr(0, newchar.length - 1);
  }
  return newchar;
}
